import { createQueryKeyStore } from '@lukemorales/query-key-factory';
import { AxiosInstance } from 'axios';

import { API_PREFIX_ADMIN } from '../../../constants.ts';

import {
    TAdminAdminsResponse,
    TAdminCreatePayload,
    TAdminCreateResponse,
    TAdminUpdatePayload,
    TAdminUpdateResponse,
} from './types.ts';

export class AdminApiAdminsService {
    #QUERY_KEYS = createQueryKeyStore({
        admins: {
            list: () => ({
                queryKey: ['admin-admins'],
                queryFn: () => this.#getAdmins(),
            }),
        },
    });

    constructor(private api: AxiosInstance) {
        this.api = api;
    }

    getAdmins() {
        return this.#QUERY_KEYS.admins.list();
    }

    createAdmin = async (payload: TAdminCreatePayload): Promise<TAdminCreateResponse> => {
        const { data } = await this.api.post<TAdminCreateResponse>(
            API_PREFIX_ADMIN + '/admins',
            payload
        );

        return data;
    };

    updateAdmin = async (
        id: number,
        payload: TAdminUpdatePayload
    ): Promise<TAdminUpdateResponse> => {
        const { data } = await this.api.put<TAdminUpdateResponse>(
            API_PREFIX_ADMIN + `/admins/${id}`,
            payload
        );

        return data;
    };

    deleteAdmin = async (id: number): Promise<void> => {
        await this.api.delete(API_PREFIX_ADMIN + `/admins/${id}`);
    };

    async #getAdmins(): Promise<TAdminAdminsResponse> {
        const { data } = await this.api.get<TAdminAdminsResponse>(API_PREFIX_ADMIN + '/admins', {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        return data;
    }
}
